// auth-context.ts
import { HttpContextToken } from '@angular/common/http';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

export const SKIP_401_HANDLER = new HttpContextToken<boolean>(() => false);
